import React from 'react'
import { EventWithDataHandler, Field, Formatter, Normalizer, Validator } from 'redux-form'

import omitBy from 'lodash/fp/omitBy'
import isUndefined from 'lodash/fp/isUndefined'
import WithFormContext from './WithFormContext'

const omitUndefined = omitBy(isUndefined)

export interface IFieldWrapperProps {
  name: string
  format?: Formatter | null | undefined
  normalize?: Normalizer
  type?: string
  validate?: Validator | Validator[]
  value?: boolean | number | string | Array<boolean | number | string>
  warn?: Validator | Validator[]
  onFormChange?: EventWithDataHandler<React.ChangeEvent<any>>

  [key: string]: any
}

const FieldWrapper = (WrappedComponent: React.StatelessComponent<any> | React.ComponentClass<any>) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  class FieldWrapper extends React.Component<IFieldWrapperProps> {
    static displayName = `FieldWrapper(${displayName})`
    static WrappedComponent = WrappedComponent

    componentDidMount() {
      this.props.registerField(this.props.name)
    }

    render() {
      const { registerField, name, formatters, format, normalize, parse, type, validate, value, warn, onFormChange, ...props } = this.props

      const innerProps = omitUndefined({
        ...props,
        type,
        value,
        formatters
      })

      return (
        <Field
          component={WrappedComponent as any}
          format={format || (formatters && formatters.format)}
          name={name}
          normalize={normalize} // runs after parse, makes sure the correct values are set in redux
          parse={parse || (formatters && formatters.parse)} // runs after change, makes sure a parsed value is passed to normalize
          type={type}
          validate={validate}
          value={value}
          warn={warn}
          // cast to any for now fix when form components get refactored
          props={innerProps as any}
          onChange={onFormChange}
        />
      )
    }
  }

  return WithFormContext<IFieldWrapperProps>(FieldWrapper)
}

export default FieldWrapper
